export const ADD_TODO = 'ADD_TODO';
export const EDIT_TODO = 'EDIT_TODO';
export const LOAD_TODO = 'LOAD_TODO';
export const TOGGLE_TODO = 'TOGGLE_TODO';
export const COLOR_SELECT_TODO = 'COLOR_SELECT_TODO';
export const DELETE_TODO = 'DELETE_TODO';
export const ALL_COMPLETED_TODO = 'ALL_COMPLETED_TODO';
export const CLEAR_COMPLETED_TODO = 'CLEAR_COMPLETED_TODO';
